import { SEAGM_CATEGORY_LIST_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { Category } from "core/models/Category";

const intialState: { categories: Category[]; count: number; isLoading: boolean } = {
  categories: [],
  isLoading: false,
  count: 0,
};

interface ActionType extends Action {
  payload: { categories: Category[]; count: number };
}

export default function seagmCategoryListReducer(state = intialState, action: ActionType) {
  switch (action.type) {
    case SEAGM_CATEGORY_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true };
    case SEAGM_CATEGORY_LIST_ACTION.SUCCESS:
      const { categories, count } = action.payload;
      return { ...state, categories, count, isLoading: false };
    case SEAGM_CATEGORY_LIST_ACTION.FAILURE:
      return { ...state, ...intialState };
    default:
      return state;
  }
}
